import gql from 'graphql-tag'

export const CREATE_WATCHER = gql`
  mutation create_watcher($input: WatcherInput) {
    create_watcher(input: $input)
      @rest(type: "Watcher", path: "/create-watcher", bodyKey: "input", method: "POST") {
      id
      name
      query
      condition
      definition
      last_updated_by
      entity_ids
      entity_type_ids
      interval
      status
      triggered_at
      result
    }
  }
`
